import { ChevronRight } from '@carbon/icons-react';
import { useParams } from 'react-router';

import { Button } from 'DesignSystem/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'DesignSystem/ui/dialog';
import track from 'features/Analytics/track';

import { CardCasesTable } from './card-cases-table';

export function CardCasesDialog({ caseCount }: { caseCount: number }) {
  const { cardId } = useParams<'cardId'>();
  if (!cardId) return null;

  const countLabel = caseCount.toLocaleString();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          onClick={() => track.pcm.viewCases()}
          variant="text"
          size="text"
          className="type-body-xs h-5 gap-0.5 p-0 font-medium text-indigo-600"
        >
          {countLabel}
          <ChevronRight size={16} />
        </Button>
      </DialogTrigger>
      <DialogContent className="flex w-[960px] max-w-[80%] bg-white">
        <div className="flex h-full w-full flex-col gap-4">
          <DialogHeader>
            <DialogTitle className="type-body-2xl pr-6 font-medium">
              {`${countLabel} Cases Used this Preference Card in Last 12 Months`}
            </DialogTitle>
            <DialogDescription className="type-body font-normal leading-[19px] text-zinc-500">
              All cases in the past 12 months that were associated with this preference card, including single and
              multipanel cases.
            </DialogDescription>
          </DialogHeader>
          <CardCasesTable cardId={cardId} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
